import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { attorneyActions } from "../../../../store/attorneys";
import CustomSelect from "../../../common/interactive/CustomSelect";

const AttorneysSearchDone = ({searchedData, path}) => {

    const dispatch = useDispatch()
    const isSearched = useSelector(state => state.attorney.searchResult)
    const [locationData, setLocationData] = useState(null)
    const [attorneysData, setAttorneysData] = useState(null)
    const [lawFirm, setLawFirm] = useState(null)

    const [selectedLocation, setSelectedLocation] = useState(null)
    const [selectedAttorney, setSelectedAttorney] = useState(null)

    useEffect(() => {
        if (isSearched) {

            let locations = isSearched.locations.map(element => {

                let locAddress

                if (element?.contact_information?.address_1 || element?.contact_information?.city || element?.contact_information?.state || element?.contact_information?.zip) {

                    locAddress = element?.contact_information ? 
                        element.contact_information.address_1
                        + ' ' + element.contact_information.city 
                        + ' ' + element?.contact_information?.state 
                        + ' ' + element?.contact_information?.zip  
                    : 
                    ''
                } else {
                    locAddress = element?.name
                }
                return { 
                    value: element.id,
                    label: locAddress,
                    code: element.code
                }
            });

            if (searchedData && locations) {  
                if (searchedData.tag == "law-firm-locations") {
                    let selected = locations.find(item => item.code == searchedData.code)
                    if (selected) {
                        setSelectedLocation(selected.value)
                        dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual({
                            identifier: 'location_id',
                            data: {
                                value: selected.value
                            }
                        }))
                    } 
                    
                } else {
                    if (locations.length > 1) {

                    } else {
                        setSelectedLocation(locations[0]?.value)
                        dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual({
                            identifier: 'location_id',
                            data: {
                                value: locations[0]?.value
                            }
                        }))
                    }
                    
                }
            }

            setLocationData(locations)
     
            let attorneys = isSearched.attorneys.map(element => {
                return { 
                    value: element.id,
                    label: element.name,
                }
            });
         
            if (searchedData && attorneys) {
                if (searchedData.tag == "law-firm-attorneys") {
                    let selected = attorneys.find(item => item.value == searchedData.id)
                    if (selected) {
                        setSelectedAttorney(selected.value)
                        dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual({
                            identifier: 'attorney_id',
                            data: {
                                value: selected.value
                            }
                        }))
                    } else {

                    }
                } else {

                    if (attorneys.length > 1) {

                    } else {
                        setSelectedAttorney(attorneys[0]?.value)
                        dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual({
                            identifier: 'attorney_id',
                            data: {
                                value: attorneys[0]?.value
                            }
                        }))
                    }
                    
                }
            }

            setAttorneysData(attorneys)

            dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual({
                identifier: 'law_firm_id',
                data: {
                    value: isSearched.id
                }
            }))

            setLawFirm([{value: isSearched.id, label: isSearched.name}])
        }

        
    }, [isSearched, searchedData])   
    
    const onChangeHandler = (data) => {
        dispatch(attorneyActions.setFirmLocationAttorneySelectionIndividual(data))

        if (data.identifier == 'location_id') {
            setSelectedLocation(data.data.value)
        }

        if (data.identifier == 'attorney_id') {
            setSelectedAttorney(data.data.value)
        }
    }   

    return <>
        {lawFirm && <div style={{width: 160}}>
            <CustomSelect label={'Low Firm'} optionsData={lawFirm} preSelectedValue={lawFirm[0]?.value} action={onChangeHandler} identifier={'law_firm_id'}/>    
        </div>}
        {locationData && <div style={{width: 160}}>
            <CustomSelect label={'Location'} optionsData={locationData} preSelectedValue={selectedLocation} action={onChangeHandler} identifier={'location_id'}/>    
        </div>}
        {locationData && <div style={{width: 160}}>
            <CustomSelect label={'Atty name'} optionsData={attorneysData} preSelectedValue={selectedAttorney} action={onChangeHandler} identifier={'attorney_id'}/>    
        </div>}
    </>
}

export default AttorneysSearchDone